/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { SectionHeadingTitle } from '@jira/issue__section-header/src/section-heading-view.tsx';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import UnlinkIcon from '@atlaskit/icon/core/link-broken';
import { Box, xcss } from '@atlaskit/primitives';
import { ExpandedFrame } from '@atlaskit/smart-card';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from '../../../../../messages.tsx';

interface Props {
	url: string;
}

export const LoomErrorCard = ({ url }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<ExpandedFrame
			allowScrollBar
			setOverflow
			frameStyle="show"
			href={url}
			inheritDimensions
			icon={<UnlinkIcon label="Unlink" color={token('color.icon')} />}
			testId="issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.loom-error-card.error-view"
			text={url}
		>
			<Box xcss={contentStyles}>
				<StatusErrorIcon label="Error" color={token('color.icon')} />
				<SectionHeadingTitle>{formatMessage(messages.loomCardErrorHeading)}</SectionHeadingTitle>
			</Box>
		</ExpandedFrame>
	);
};

const contentStyles = xcss({
	textAlign: 'center',
	alignContent: 'center',
	font: token('font.body'),
	height: '100%',
});
